import { z } from 'zod';

export const getLoginSchema = ({
  isEmailRequired,
  isPasswordRequired,
}: {
  isEmailRequired: boolean;
  isPasswordRequired: boolean;
}) =>
  z.object({
    email: isEmailRequired ? z.string().email() : z.string().email().optional(),
    password: isPasswordRequired ? z.string() : z.string().optional(),
  });
